import React from 'react';
import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Code, Container, List, ListItem, Text } from '@chakra-ui/react';

const ConfigErrorPage = ({ missing }) => (
  <Container maxW="container.md" py={16}>
    <Alert status="error" borderRadius="md" alignItems="flex-start">
      <AlertIcon />
      <Box>
        <AlertTitle mb={2}>HoggedIn is not configured</AlertTitle>
        <AlertDescription>
          <Text mb={2}>The following required environment variables are missing:</Text>
          <List spacing={1} mb={2}>
            {missing.map((name) => (
              <ListItem key={name}>
                <Code>{name}</Code>
              </ListItem>
            ))}
          </List>
          <Text>
            Copy <Code>.env.template</Code> to <Code>.env.local</Code>, fill in the values and restart the app.
          </Text>
        </AlertDescription>
      </Box>
    </Alert>
  </Container>
);

export default ConfigErrorPage;
